import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/globals.css';
import './index.css';
import App from './App';
import { clearLegacyDemo } from './utils/clearLegacyDemo';

/* Apply theme to html before first paint so global bg matches dashboard everywhere */
(function setInitialTheme() {
  try {
    const v = localStorage.getItem('isNightMode');
    const isNight = v !== null ? JSON.parse(v) : true;
    document.documentElement.className = isNight ? 'night' : 'day';
    document.documentElement.setAttribute('data-theme', isNight ? 'dark' : 'light');
  } catch {
    document.documentElement.className = 'night';
    document.documentElement.setAttribute('data-theme', 'dark');
  }
})();

clearLegacyDemo();

/* Chrome/WebView 154 on Android only focuses time inputs on tap without opening the picker */
if (/Android/i.test(navigator.userAgent)) {
  document.addEventListener('click', (e) => {
    const el = e.target;
    if (el instanceof HTMLInputElement && el.type === 'time' && !el.disabled && !el.readOnly) {
      try { el.showPicker(); } catch {}
    }
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
